// src/Layout/Permissions/PermissionsProvider.tsx
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "slices/app/store/store";
import { setInMemoryPermissions } from "./permissionsCache";

const PermissionsProvider = ({ children }: { children: React.ReactNode }) => {
  const permissions = useSelector((state: RootState) => state.Login.permissions);

  useEffect(() => {
    setInMemoryPermissions(permissions);
  }, [permissions]);

  return <>{children}</>;
};

export default PermissionsProvider;
